import noUiSlider from "nouislider";
import wnumb from "wnumb";

// this === vue component
export function initRangeSlider(sliderElContainer){
    var stepsSlider = sliderElContainer.querySelector('#steps-slider'),
        inputs = [
            sliderElContainer.querySelector('#input-with-min'),
            sliderElContainer.querySelector('#input-with-max')
        ];
    noUiSlider.create(stepsSlider, {
        start: [
            this.modelValue.min === null ? this.options.min : this.modelValue.min,
            this.modelValue.max === null ? this.options.max : this.modelValue.max,
        ],
        connect: true,
        format: wnumb({decimals: 0}),
        range: {
            'min': this.options.min,
            'max': this.options.max
        }
    });

    stepsSlider.noUiSlider.on('change', () => {
        this.$emit('change')
    });

    stepsSlider.noUiSlider.on('update', (values, handle) => {
        inputs[handle].value = values[handle];
        this.$emit('update:modelValue', {'min': parseInt(inputs[0].value), 'max': parseInt(inputs[1].value)});
    });

    inputs.forEach((input, handle) => {
        input.addEventListener('change', function () {
            stepsSlider.noUiSlider.setHandle(handle, this.value);
        });
    });
}